import { Injectable } from '@angular/core';
import { Observable, catchError, throwError, timeout } from 'rxjs';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

// const API_URL = 'http://localhost:9180/ova/api/oportunidades';
// const API_URL_SEMAFORIZACION =' http://localhost:9180/ova/api/oportunidades/consultarReglasDeSemaforizacion';
// const API_URL_MODAL = 'http://localhost:9180/ova/api/oportunidades/mostrarMensajeModal';
// const API_URL = ENV.API.OPORTUNIDADES_COMERCIALES_INTERNOS;
const API_URL = `${ENV.HOST}${URL_MAP.API.OPORTUNIDADES_COMERCIALES_INTERNOS}`;
// const API_URL_SEMAFORIZACION = ENV.API.OPORTUNIDADES_COMERCIALES_INTERNOS_SEMAFORIZACION;
const API_URL_SEMAFORIZACION = `${ENV.HOST}${URL_MAP.API.OPORTUNIDADES_COMERCIALES_INTERNOS_SEMAFORIZACION}`;
// const API_URL_MODAL = ENV.API.OPORTUNIDADES_COMERCIALES_INTERNOS_MODAL;
const API_URL_MODAL = `${ENV.HOST}${URL_MAP.API.OPORTUNIDADES_COMERCIALES_INTERNOS_MODAL}`;

const TIMEOUT_MS = 15000; // 15 segundos de timeout

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class OportunidadComercialService {
  constructor(private httpClient: HttpClient) {}

  // Consulta con filtros complejos
  getOportunidadesFiltradas(filtros: any): Observable<any> {
    return this.httpClient
      .post(`${API_URL}/consultar`, filtros, httpOptions)
      .pipe(timeout(TIMEOUT_MS), catchError(this.handleError));
  }

  public consultarReglasDeSemaforizacion(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const requestBody = {
      nombreClave: 'getOportunidadComercial',
      queryParams: '?page=0&size=1000',
      pathVariables: null,
      body: null,
    };

    return this.httpClient
      .post<any>(API_URL_SEMAFORIZACION, requestBody, { headers })
      .pipe(timeout(TIMEOUT_MS), catchError(this.handleError));
  }

  public mostrarMensajeModal(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const requestBody = {
      nombreClave: 'getAlertMessage'
    };

    return this.httpClient
      .post<any>(API_URL_MODAL, requestBody, { headers })
      .pipe(timeout(TIMEOUT_MS), catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let mensaje = 'Ha ocurrido un error inesperado.';
    if (error.error instanceof ErrorEvent) {
      mensaje = `Error de red o cliente: ${error.error.message}`;
    } else {
      switch (error.status) {
        case 400:
          mensaje = 'Solicitud incorrecta.';
          break;
        case 404:
          mensaje = 'Recurso no encontrado.';
          break;
        case 500:
          mensaje = 'Error del servidor.';
          break;
        default:
          mensaje = `Código de error: ${error.status}, mensaje: ${error.message}`;
          break;
      }
    }
    return throwError(() => new Error(mensaje));
  }
}
